import { resolveKeysInObjectsArrays, appPrefix } from 'utils/browserHelper'
const POPULAR_AIRPORTS = {
    JED: {
        ar: 'جدة, SA - مطار الملك عبد العزيز الدولي (JED)',
        en: 'Jeddah, SA - Jeddah'
    },
    DXB: {
        ar: 'دبى, AE - مطار دبي الدولي (DXB)',
        en: 'Dubai, AE - Dubai International Airport'
    },
    RUH: {
        ar: 'الرياض, SA - مطار الملك خالد الدولي (RUH)',
        en: 'Riyadh, SA - King Khaled'
    },
    BLR: {
        ar: 'بنجالور, IN - مطار بنجالور (BLR)',
        en: 'Bangalore, IN - Kempegowda International Airport (BLR)'
    },
    DEL: {
        ar: 'نيو دلهي, IN - مطار دلهي انديرا غاندي الدولي (DEL)',
        en: 'New Delhi, IN - Indira Gandhi Airport (DEL)'
    },
    COK: {
        ar: 'كوشين, IN - مطار كوتشين (COK)',
        en: 'Kochi, IN - Cochin International Airport (COK)'
    },
    HYD: {
        ar: 'حيدراباد, IN - مطار بيغومبيت (HYD)',
        en: 'Hyderabad, IN - Rajiv Gandhi International (HYD)'
    },
    CCJ: {
        ar: 'كوزيكود, IN - مطار كاليكوت الدولي (CCJ)',
        en: 'Kozhikode, IN - Kozhikode (CCJ)'
    }
}
export const getPopularCities = () => {
    const domain = resolveKeysInObjectsArrays(['location', 'hostname'], window)
    const lang = appPrefix === '/ar' ? 'ar' : 'en'
    switch (domain) {
        case 'www.cleartrip.ae':
        case 'qa2.cleartrip.ae':
        case 'me.cleartrip.ae':
        case 'www.cleartrip.ae':
        case 'www.cleartrip.sa':
        case 'qa2.cleartrip.sa':
        case 'me.cleartrip.sa':
        case 'www.cleartrip.sa':
        case 'bh.cleartrip.com':
        case 'bh.cleartrip.sa':
        case 'www.cleartrip.bh':
        case 'www.cleartrip.bh':
        case 'om.cleartrip.com':
        case 'om.cleartrip.sa':
        case 'www.cleartrip.om':
        case 'www.cleartrip.om':
        case 'kw.cleartrip.com':
        case 'kw.cleartrip.sa':
        case 'www.cleartrip.com.kw':
        case 'www.cleartrip.kw':
        case 'qa.cleartrip.com':
        case 'qar.cleartrip.sa':
        case 'www.cleartrip.qa':
        case 'www.cleartrip.qa':
            return [
                { k: 'DXB', v: POPULAR_AIRPORTS.DXB[lang] },
                { k: 'RUH', v: POPULAR_AIRPORTS.RUH[lang] },
                { k: 'BLR', v: POPULAR_AIRPORTS.BLR[lang] },
                { k: 'DEL', v: POPULAR_AIRPORTS.DEL[lang] },
                { k: 'COK', v: POPULAR_AIRPORTS.COK[lang] },
                { k: 'HYD', v: POPULAR_AIRPORTS.HYD[lang] },
                { k: 'CCJ', v: POPULAR_AIRPORTS.CCJ[lang] }
            ]
        default:
            return [
                { k: 'BLR', v: 'Bangalore, IN - Kempegowda International Airport (BLR)' },
                { k: 'BOM', v: 'Mumbai, IN - Chatrapati Shivaji Airport (BOM)' },
                { k: 'DEL', v: 'New Delhi, IN - Indira Gandhi Airport (DEL)' },
                { k: 'CCU', v: 'Kolkata, IN - Netaji Subhas Chandra Bose Airport (CCU)' },
                { k: 'GOI', v: 'Goa, IN - Dabolim Airport (GOI)' },
                { k: 'HYD', v: 'Hyderabad, IN - Rajiv Gandhi International (HYD)' },
                { k: 'MAA', v: 'Chennai, IN - Chennai Airport (MAA)' }
            ]
    }
}
const data = {
    optionA: [
        {
            id: 1,
            label: 'One way',
            value: 'oneway',
            selected: true
        },
        {
            id: 2,
            label: 'Round trip',
            value: 'rt',
            selected: false
        }
        // {
        //     id: 3,
        //     label: 'Multi city',
        //     value: 'multiple',
        //     selected: false
        // }
    ],
    popular: getPopularCities()
}

export default data
